/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModelResult } from '../../models/user-model-result';

export interface ApiMenuGet$JsonOdataMetadataNone$Params {
}

export function apiMenuGet$JsonOdataMetadataNone(http: HttpClient, rootUrl: string, params?: ApiMenuGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiMenuGet$JsonOdataMetadataNone.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserModelResult>;
    })
  );
}

apiMenuGet$JsonOdataMetadataNone.PATH = '/api/menu';
